import Vue from 'vue';
import Vuex from 'vuex';
import jwt from 'jsonwebtoken';
import { RootState, AlertPayload, PlayerProfile} from '@/types/store';

Vue.use(Vuex);

export default new Vuex.Store<RootState>({
  state: {
    loggedIn: false,
    alert: null,
    token: null,
    profile: null,
  },
  mutations: {
    setAlert(state, payload: AlertPayload) {
      state.alert = {
        type: payload.type,
        text: payload.text,
      };
    },
    setToken(state, token) {
      localStorage.setItem('userToken', token);
      state.token = token;
      state.loggedIn = true;
      state.profile = jwt.decode(token) as PlayerProfile;
    },
    dismissAlert(state) {
      state.alert = null;
    },
  },
  actions: {

  },
});
